export default {
  root: {
    color: 'inherit',
    marginBottom: 48
  }
};
